import { adjustInputWidth } from "./auto_width_input.js";
import { formatAmount, parseAmount } from "./format_amount.js";

export const DonationAmount = {
  mounted() {
    adjustInputWidth(this.el);

    this.el.addEventListener("keydown", (e) => {
      if (
        e.key.length === 1 &&
        !e.metaKey &&
        !e.ctrlKey &&
        !/[0-9]/.test(e.key)
      ) {
        e.preventDefault();
      }
    });

    this.el.addEventListener("input", () => {
      const raw = parseAmount(this.el.value);
      if (!isNaN(raw) && raw > 0) {
        const formatted = formatAmount(raw);
        if (this.el.value !== formatted) {
          const cursorFromEnd = this.el.value.length - this.el.selectionStart;
          this.el.value = formatted;
          const newPos = Math.max(0, formatted.length - cursorFromEnd);
          this.el.setSelectionRange(newPos, newPos);
        }
      }
      adjustInputWidth(this.el);
      const currency = this.el.dataset.currency || "";
      const btn = document.getElementById("donate-btn-amount");
      if (btn) btn.textContent = `${currency}${this.el.value}`;
    });
  },

  updated() {
    adjustInputWidth(this.el);
  },
};
